import OnBoardingContainer from "@/components/OnboardingContainer";
import ResetPasswordForm from "./components/ResetPasswordForm";

const ResetPassword = () => {
  return (
    <OnBoardingContainer>
      <ResetPasswordForm />
    </OnBoardingContainer>
  )
}

export default ResetPassword;
